<template>
  <component :is="comName"></component>
</template>

<script>

import Index from "@/views/home/Index";
import IndexIns from "@/views/home/IndexIns";
import IndexEmpty from "@/views/home/IndexEmpty";
import IndexCmdCenter from "@/views/home/IndexCmdCenter";


import {getStaffDTO} from "@/utils/auth";
import {commandCenterRoleName, govRoleName, insRoleName} from "@/common/const";

export default {
  name: "Switchover",

  data() {
    return {
      comName: '',
    }
  },
  components: {
    Index,IndexIns,IndexEmpty,IndexCmdCenter
  },
  created() {
    this.judge();
  },
  methods: {

    judge() {

      let roleName = getStaffDTO().roleName;
      //console.log(getStaffDTO());
      if(roleName == govRoleName){
        this.comName='Index';
      }
      else if(roleName == commandCenterRoleName){
        this.comName='IndexCmdCenter';
      }
      else if(roleName == insRoleName){
        this.comName='IndexIns';
      }
      else{
        this.comName='IndexEmpty';
      }

    }



  }


}
</script>